import React, { useContext } from "react";
import styled from "@emotion/styled";
import { AnimatePresence } from "framer-motion";

import Context from "./Context";

// style rules
import { Sizes } from "../../styles";
import MediaCard from "./MediaCard";
import SidePanel from "./SidePanel";
import Pagination from "../pagination/Pagination";
import MediaGridNoResults from "./MediaGridNoResults";

const MediaGrid = () => {
	const {
		data: {
			mediaItems,
			isSidePanelOpen,
			selectedMediaItem,
			totalPages,
			currentPageNumber,
		},
		actions: {
			handleButtonPageSelect,
			handleDecrementPage,
			handleIncrementPage,
		},
	} = useContext(Context);

	const renderMediaCards = () => {
		if (mediaItems.length == 0) {
			return <MediaGridNoResults text={"No Media items found"} />;
		}
		return mediaItems.map((item) => {
			return <MediaCard key={item.slug} mediaItem={item} />;
		});
	};

	return (
		<>
			<Grid isEmpty={mediaItems.length == 0}>
				{renderMediaCards()}
				<AnimatePresence>
					{isSidePanelOpen && selectedMediaItem && (
						<SidePanel selectedMediaItem={selectedMediaItem} />
					)}
				</AnimatePresence>
			</Grid>
			{totalPages && totalPages.length > 0 && (
				<Pagination
					handleDecrementPage={handleDecrementPage}
					handleIncrementPage={handleIncrementPage}
					totalPages={totalPages}
					handleButtonPageSelect={handleButtonPageSelect}
					currentPageNumber={currentPageNumber}
				/>
			)}
		</>
	);
};

export default MediaGrid;

const Grid = styled.ul`
	display: ${(props) => (props.isEmpty ? "block" : "grid")};
	grid-template-columns: 1fr;
	gap: 2.8rem;
	padding: 5.4rem 0 12rem 0;
	margin: 0;
	max-width: unset;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		grid-template-columns: repeat(auto-fill, minmax(29rem, 1fr));
	}
`;
